module.exports = __webpack_public_path__ + "img/coupon.7693ba2b.svg";